import React from 'react';

import type { Props as LinkProps } from 'Elements/Link';

import { SocialStyled, IconStyled } from './Social.styled';

export interface Props {
    icon: {
        as: React.ElementType;
        colour?: string;
    };
    link: LinkProps;
}

const Social: React.FC<Props> = props => {
    const { icon, link } = props;

    return (
        <SocialStyled {...link} label={undefined}>
            <IconStyled
                as={icon.as}
                style={{ '--sup-social-colour': icon.colour } as React.CSSProperties}
            />
            {link.label}
        </SocialStyled>
    );
};

export default Social;
